var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioDescribed = function SvgAudioDescribed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.168a11.5 11.5 0 0 1 16.264 0M6.827 8a7.5 7.5 0 0 1 10.607 0M12 10.75c-4.031-.06-8.2 2.444-10.821 5.009a1.36 1.36 0 0 0 0 1.979C3.743 20.248 7.9 22.81 12 22.748c4.1.062 8.258-2.5 10.824-5.01.57-.563.57-1.417 0-1.979C20.2 13.194 16.031 10.69 12 10.751z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.75a3.75 3.75 0 1 1-7.5-.002 3.75 3.75 0 0 1 7.5.002"
  }))));
};
export default SvgAudioDescribed;